import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";

import { closeModal } from "@/components/modals/baseModal";
import { closeAlert } from "@/components/organisms/alert";
import type { IErrorCode } from "@/templates/errors/view";
import { ErrorView } from "@/templates/errors/view";

export function ErrorPage() {
  const error = useRouteError();

  Sentry.captureException(error as Error);

  let errorMessage = "";
  let errorCode = 500;
  let isFront = true;

  useEffect(() => {
    closeModal();
    closeAlert();
  }, []);

  if (isRouteErrorResponse(error)) {
    Sentry.setTags({
      routerError: "router-error",
      errorMessage: error.data,
      errorCode: error.status,
    });
    Sentry.captureException(error.data);

    errorMessage = error.data;
    errorCode = error.status;
  } else if (error instanceof Error) {
    Sentry.setTags({
      routerError: "router-front-error",
      errorMessage: error.message,
    });
    Sentry.captureException(error);

    errorMessage = error.message;
  } else if (typeof error === "string") {
    Sentry.setTags({
      routerError: "router-front-string",
      errorMessage: error,
    });
    Sentry.captureException(error);

    errorMessage = error;
  } else if (typeof error === "object") {
    const errorObj = error as { data: string; status: number };

    if (errorObj.status) {
      Sentry.setTags({
        routerError: "router-backend",
        errorMessage: errorObj?.data?.toString(),
        errorCode: errorObj.status,
      });
      Sentry.captureException(errorObj.data?.toString());

      errorMessage = errorObj.data?.toString();
      errorCode = errorObj.status;
      isFront = false;
    }
  }

  if (error && typeof error === "object" && "error" in error) {
    Sentry.captureException(error?.error);
  }

  if ([404, 500, 503, 400, 403]?.includes(errorCode))
    return <ErrorView errorCode={errorCode as IErrorCode} isFront={isFront} />;

  Sentry.setTags({
    routerError: "router-unknown",
  });
  Sentry.captureException(error);

  return (
    <div>
      <h1>{errorCode}</h1>
      <p>
        <i>{errorMessage}</i>
      </p>
    </div>
  );
}
